import { ApiResponse } from "../domain/models/http/Response";
import { Search, SearchRequest } from "../domain/models/http/SearchRequest";
import IQueryRepository from "../domain/ports/IQueryRepository";
import Service from "./Service";

const NEXT_PAGE = 2;

abstract class QueryService<T>
  extends Service<T>
  implements IQueryRepository<T>
{
  constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL);
  }

  public async search(body?: SearchRequest): Promise<ApiResponse<T>> {
    const response = await this.api.post(`${this.pathname}/search`, {
      ...body,
    });

    return response.data;
  }

  protected async getAllData(
    searchParams: Search,
    limit: number = 50,
  ): Promise<T[]> {
    try {
      const firstResponse = await this.search({
        search: { ...searchParams, limit },
      });

      if (firstResponse.last_page <= 1) {
        return firstResponse.data;
      }

      const promisesResponses = [];
      for (let page = NEXT_PAGE; page <= firstResponse.last_page; page++) {
        promisesResponses.push(
          this.search({ search: { ...searchParams, page, limit } }),
        );
      }

      const allPromisesResponses = await Promise.all(promisesResponses);

      const data: T[] = [...firstResponse.data];
      for (const promiseResponse of allPromisesResponses) {
        data.push(...promiseResponse.data);
      }
      return data;
    } catch (error) {
      console.error("QueryService.getAllData error", error);
      throw error;
    }
  }
}

export default QueryService;
